import React from 'react';
import { motion } from 'framer-motion';
export function HIPAA() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white min-h-screen py-20" data-id="element-416" data-mp="20fdigvb6u5yl">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-417" data-mp="24ffaecr4fl0o">
        <h1 className="text-4xl font-black text-slate-900 mb-8 uppercase tracking-tighter" data-id="element-418" data-mp="29gbm3chpsbgn">
          HIPAA Notice
        </h1>
        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed" data-id="element-419" data-mp="2eemvjm43kjyc">
          <p className="text-lg font-medium text-slate-900" data-id="element-420" data-mp="2jcoem71iwj9t">
            Notice of Privacy Practices
          </p>
          <p data-id="element-421" data-mp="2o5r8kga7puqj">
            This notice describes how medical information about you may be used
            and disclosed and how you can get access to this information. Please
            review it carefully.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-422" data-mp="2x3t96uq1alda">
            Our Legal Duty
          </h2>
          <p data-id="element-423" data-mp="1x30wjimn1sd5">
            We are required by applicable federal and state law to maintain the
            privacy of your health information. We are also required to give you
            this notice about our privacy practices, our legal duties, and your
            rights concerning your health information.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-424" data-mp="1j41bekyc3vlq">
            Uses and Disclosures of Health Information
          </h2>
          <p data-id="element-425" data-mp="2fsqswa61um76">
            We use and disclose health information about you for treatment,
            payment, and healthcare operations. For example, we may disclose
            your health information to a physician or other healthcare provider
            providing treatment to you.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-426" data-mp="221vgwp097ozd">
            Your Rights
          </h2>
          <p data-id="element-427" data-mp="2ziu9i8i2p2fi">
            You have the right to look at or get copies of your health
            information, with limited exceptions. You also have the right to
            request that we amend your health information or place additional
            restrictions on our use or disclosure of your health information.
          </p>
        </div>
      </div>
    </motion.div>;
}